document.addEventListener('DOMContentLoaded', () => {
  const notices = document.querySelector('[data-checkout-notices]');
  if (!notices || !window.csrfTokenValue) return;

  fetch('/actions/pro/cart/clear-notices/', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'X-CSRF-Token': window.csrfTokenValue,
    },
    credentials: 'same-origin',
  }).catch((error) => {
    console.error('Unable to clear cart notices:', error);
  });
});
